module.exports = __webpack_public_path__ + "static/media/YM06_6.21f60d25.jpg";